import { SubProduct } from '../product'

export const LAUNCHING_PRODUCTS_AVAIBILITY = {
  dashboard: [
    'dashboard',
    'datadownload',
    'analytics',
    'market_overview',
    'deal_center',
    'analyzer',
  ],
  datadownload: ['dashboard', 'datadownload'],
  analytics: ['dashboard', 'analytics', 'market_overview', 'deal_center'],
  market_overview: ['market_overview', 'dashboard', 'analytics', 'deal_center'],
  deal_center: ['deal_center', 'dashboard', 'analytics', 'market_overview'],
  deal_alert: ['deal_center', 'dashboard'],
  analyzer: ['analyzer', 'dashboard'],
  prebid_analytics: ['prebid_analytics'],
  [SubProduct.AnalyticsV2]: [SubProduct.AnalyticsV2],
  benchmark_comparison: [SubProduct.AnalyticsV2, 'dashboard', 'datadownload'], // Not a sub-product, but a special case to dif
  [SubProduct.DealAlertsV2]: [SubProduct.DealCenterV2, SubProduct.Dashboard],
  [SubProduct.DealCenterV2]: [SubProduct.DealCenterV2, SubProduct.Dashboard],
  [SubProduct.StreamingAnalytics]: [SubProduct.StreamingAnalytics],
}

export const FROM_CROSS_LAUNCHING_KEY = 'cross_launch_in'

export const FROM_SMART_ANALYSIS_KEY = 'smart_analysis'
